module.exports = __webpack_public_path__ + "static/img/companyGrow1.0918238.png";


//////////////////
// WEBPACK FOOTER
// ./static/companyGrow1.png
// module id = QgaX
// module chunks = 7